import React, { useState } from 'react';

// Mui components
import Dialog from '@mui/material/Dialog';
import {
  Typography,
  Box,
  DialogContent,
  IconButton,
  DialogTitle,
  CircularProgress,
} from '@mui/material';

// Icons
import {
  DialogCloseCIcon,
  LeftArrowSlideCIcon,
  ModalCrossCIcon,
  RightArrowSlideCIcon,
} from '~/assets/images';

// Styles
import './styles.scss';

const ThumbnailModal = (props) => {
  const { onClose, openThumbnailModal, templates } = props;
  const [showBackThumbnail, setShowBackThumbnail] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);

  const handleShowBackThumbnail = (value) => {
    setShowBackThumbnail(value);
    setImageLoading(true);
  };

  const template = templates.rows.find((template) => template.id === openThumbnailModal.id);

  const handleClose = () => {
    onClose();
    setShowBackThumbnail(false);
    setImageLoading(true);
  };

  const handleImageLoad = () => {
    setImageLoading(false);
  };

  return (
    <Dialog
      open={openThumbnailModal.open}
      onClose={handleClose}
      aria-label="Template preview"
      classes={{
        root: 'thumbnailModal',
        paper: 'modalPaper',
      }}
    >
      <DialogTitle className="modalTitle">
        {!imageLoading && (
          <IconButton
            aria-label="Close template preview"
            onClick={handleClose}
            className="closeIcon"
          >
            <img src={DialogCloseCIcon} alt="close" />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent className="modalContent">
        {/* loading image */}
        {imageLoading && (
          <Box className="imageLoadingBox">
            <CircularProgress className="imageLoadingProgress" />
          </Box>
        )}
        {/* image */}
        <img
          src={showBackThumbnail ? template?.backThumbnailUrl : template?.thumbnailUrl}
          alt="template"
          onLoad={handleImageLoad}
          style={{ display: imageLoading ? 'none' : 'block' }}
        />
        {/* thumbnail modal content */}
        {!imageLoading && (
          <Box className="thumbnailModalContent">
            <Typography>{template?.title}</Typography>
          </Box>
        )}
        {/* thumbnail arrows */}
        {template?.backThumbnailUrl && !imageLoading && (
          <>
            <img
              src={LeftArrowSlideCIcon}
              alt=""
              className={`leftArrow ${!showBackThumbnail ? 'disabled' : ''}`}
              role="button"
              tabIndex={showBackThumbnail ? 0 : -1}
              aria-label="Show template front"
              aria-disabled={!showBackThumbnail}
              onClick={showBackThumbnail ? () => handleShowBackThumbnail(false) : undefined}
              onKeyDown={(event) => {
                if (showBackThumbnail && (event.key === 'Enter' || event.key === ' ')) {
                  event.preventDefault();
                  handleShowBackThumbnail(false);
                }
              }}
            />
            <img
              src={RightArrowSlideCIcon}
              alt=""
              className={`rightArrow ${showBackThumbnail ? 'disabled' : ''}`}
              role="button"
              tabIndex={!showBackThumbnail ? 0 : -1}
              aria-label="Show template back"
              aria-disabled={showBackThumbnail}
              onClick={!showBackThumbnail ? () => handleShowBackThumbnail(true) : undefined}
              onKeyDown={(event) => {
                if (!showBackThumbnail && (event.key === 'Enter' || event.key === ' ')) {
                  event.preventDefault();
                  handleShowBackThumbnail(true);
                }
              }}
            />
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ThumbnailModal;
